// extracted by mini-css-extract-plugin
export var brand = "_1u-9";
export var compact = "_1u-6";
export var extraSmall = "_1u-7";
export var icon = "_1u-0";
export var large = "_1u-4";
export var light = "_1u-1";
export var medium = "_1u-5";
export var outline = "_1u-b";
export var primaryDark = "_1u-a";
export var primaryLight = "_1u-8";
export var primaryModern = "_1u-c";
export var success = "_1u-2";
export var successSolid = "_1u-3";